import { IAsphaltDesignImperial } from '@/modules/design/interfaces/newAsphalt';
import { IAsphaltOutputObj, ILayerDef } from '@/modules/design/interfaces/shared';
import { designStore } from '@/store/store';

export const getAsphaltLayers = function (scenario:IAsphaltDesignImperial, thicknessUnit: string, results?: IAsphaltOutputObj | null) {
  const layers: ILayerDef[] = [];

  const suggestedSurfaceThickness_in = results ? results.layers[0].depth : undefined;
  
  
  if (scenario.multipleLifts) {
    scenario.surfaceLayers.forEach((L, i) => {
      layers.push({
        unit: thicknessUnit,
        thickness: results ? results.layers[i].depth : L.thickness,
        name: L.liftTitle,
        type: 'asphalt',
        coefficient: L.coefficient,
        modulus: L.modulus,
        drainage: L.drainage
      });
    });
  } else {
    let suggestedText = '';
    if (suggestedSurfaceThickness_in) {
      suggestedText = 'Recommended ';
    }

    layers.push({
      unit: thicknessUnit,
      thickness: suggestedSurfaceThickness_in || scenario.minimumThickness,
      name: `${suggestedText}Surface`,
      type: 'asphalt',
    });
  }

  scenario.substructureLayers.forEach((L, i) => {
    if (results) {
      layers.push({
        unit: thicknessUnit,
        thickness: scenario.multipleLifts ? results.layers[i + 3].depth : results.layers[i + 1].depth,
        name: L.name || 'Layer Name',
        type: 'base',
        coefficient: L.coefficient,
        modulus: L.modulus,
        drainage: L.drainage
      });
    } else {
      layers.push({
        unit: thicknessUnit,
        thickness: L.thickness,
        name: L.name || 'Layer Name',
        type: 'base',
      });
    }
  });

  return layers;
};
